import { Alert, type AlertColor } from '@mui/material'

export const ResponseAlertNotification: React.FC<{
  alertSeverity: AlertColor | null
}> = ({ alertSeverity, children }) => {
  if (!alertSeverity) return null

  return (
    <Alert
      data-testid="test-status-check-integration-alert"
      severity={alertSeverity}
    >
      {children}
    </Alert>
  )
}
